import React from 'react';

interface CategoryPageHeader {
	Icon: string;
	Category: string;
	Title: string;
}

interface CategorySecondaryPageTitleProps {
	categoryPageHeader: CategoryPageHeader | null | undefined;
}

export default function CategorySecondaryPageTitle({categoryPageHeader}: CategorySecondaryPageTitleProps) {

	if (!categoryPageHeader) return null;

	return (<>
        <div className="container">
            <div className="row row-50">
                <div className="col-md-12 col-lg-12 col-xl-12">
                    <h2>
                            <span className={`icon icon-xl text-primary mdi ${categoryPageHeader.Icon}`}></span>
                            {categoryPageHeader.Category}
                    </h2>
                    {categoryPageHeader.Title}
                </div>
            </div>       
        </div> 
	</>)
}
